import React, { useEffect } from 'react';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import { BodyText } from '@paypalcorp/pp-react';
import ConfirmationSocialShare from './ConfirmationSocialShare';
import ConfirmationTransactionId from './ConfirmationTransactionId';
import OfferConfirmation from '../components/offerConfirmation';
import PropTypes from 'prop-types';
import SignUpAlert from '../components/guest/SignUpAlert';
import VoucherFlowDisclaimer from '../components/voucherFlowDisclaimer';
import ConfirmationRedirect from './ConfirmationRedirect';
import { endCustomCPLTrackingForConfirmationPage } from '../utility/cpl';
import {
  isInContext,
  isMobileOrInContext,
  onComplete,
  isMWebNoReturnURL,
} from '../utility/inContextDonation';
import {
  isPPCampaign,
  isGNC,
  isPPFundraising,
} from '../utility/productIntegrationUtils';
import CloseButton from '../components/CloseButton';
import classNames from 'classnames';
import DoneLink from './DoneLink';
import { BannerImage } from '@paypalcorp/donate-react';
import { isCampaigns } from '../utility/productIntegrationUtils';

const campaignMessages = localsMessages('landing');

function ConfirmationView(props) {
  const {
    autoRedirect,
    autoRedirectUrl,
    autoRedirectMethod,
    footer,
    handleRedirect,
    hostedButtonId,
    illustration,
    isSignUp,
    isVoucherFlow,
    message,
    messages,
    offerProgram,
    orgName,
    postBackData,
    returnTo,
    returnText,
    signUpProps,
    syncReturnUrl,
    txnId,
    personalizedMessages,
    isExternalFlow,
    campaignId,
  } = props;

  useEffect(() => {
    endCustomCPLTrackingForConfirmationPage();
  }, []);

  useEffect(() => {
    onComplete(postBackData);
  }, []);

  function showSocialShare() {
    if (TemplateData.socialSharePreference) {
      return (
        <ConfirmationSocialShare
          hostedButtonId={hostedButtonId}
          campaignId={campaignId}
          orgName={orgName}
          messages={isCampaigns() ? campaignMessages : messages}
          email={TemplateData.donationEmail}
          personalizedMessages={personalizedMessages}
        />
      );
    }

    return null;
  }

  function confirmationClass() {
    return classNames(
      {
        gn_donate_wrapper: TemplateData.bannerUrl,
        context_gn_wrapper: isPPCampaign() || isGNC(),
        donate_wrapper: !TemplateData.bannerUrl,
        confirmation: !TemplateData.bannerUrl,
      },
      { mobile_view: isMobileOrInContext() },
      {
        mobile_view_without_return_message: isMWebNoReturnURL(),
      },
      { ppf: isPPFundraising() }
    );
  }

  return (
    <div>
      {isSignUp && <SignUpAlert {...signUpProps} />}
      <div className={confirmationClass()}>
        {isExternalFlow && <CloseButton inverse />}
        {TemplateData.bannerUrl ? (
          <BannerImage src={TemplateData.bannerUrl} />
        ) : (
          <div> {illustration} </div>
        )}
        <div className="success_content">
          {message}

          {isExternalFlow && personalizedMessages.success_subheader ? (
            <BodyText className="text-center success_subheader">
              {personalizedMessages.success_subheader}
            </BodyText>
          ) : null}

          {isVoucherFlow && (
            <OfferConfirmation offerProgram={offerProgram} txnId={txnId} />
          )}

          {isVoucherFlow && <VoucherFlowDisclaimer />}

          {showSocialShare()}

          {!isExternalFlow && (
            <ConfirmationTransactionId transactionId={txnId} />
          )}

          {isExternalFlow && (
            <DoneLink
              doneContent={messages.label.doneButton}
              syncReturnUrl={syncReturnUrl}
              redirectUrl={autoRedirectUrl}
            />
          )}
        </div>
      </div>
      {!isInContext() && autoRedirect && autoRedirectUrl && (
        <ConfirmationRedirect
          autoRedirectMethod={autoRedirectMethod}
          autoRedirectUrl={autoRedirectUrl}
          handleRedirect={handleRedirect}
          orgName={orgName}
          postBackData={postBackData}
          returnText={returnText}
          returnTo={returnTo}
          syncReturnUrl={syncReturnUrl}
        />
      )}
      {footer}
    </div>
  );
}

ConfirmationView.propTypes = {
  autoRedirectMethod: PropTypes.string,
  autoRedirect: PropTypes.bool,
  autoRedirectUrl: PropTypes.string,
  footer: PropTypes.object,
  handleRedirect: PropTypes.func,
  hostedButtonId: PropTypes.string,
  isVoucherFlow: PropTypes.bool,
  illustration: PropTypes.object,
  isSignUp: PropTypes.bool,
  message: PropTypes.object,
  messages: PropTypes.object,
  offerProgram: PropTypes.object,
  orgName: PropTypes.string,
  postBackData: PropTypes.object,
  redirect: PropTypes.func,
  returnTo: PropTypes.string,
  returnText: PropTypes.string,
  signUpProps: PropTypes.object,
  syncReturnUrl: PropTypes.string,
  txnId: PropTypes.string,
  personalizedMessages: PropTypes.object,
  isExternalFlow: PropTypes.bool,
  isOfacPending: PropTypes.bool,
  campaignId: PropTypes.string,
};

export default ConfirmationView;
